export default function immutableSort(array, extend, sortFunc) {
  const clone = array.concat(extend);
  clone.sort(sortFunc);
  return clone;
}
